import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Braintree_customer } from '../models/accounting/banking/braintree_customer';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class PaymentCustomerService {

  constructor(private http: HttpClient) { }

  get_list(): Promise<Braintree_customer[]> {
  	return this.getListWithRest("");
  }

  private getListWithRest(rest_url: string) : Promise<Braintree_customer[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'accounting/banking/braintree_customers' + rest_url).subscribe((response:any) => {
			if(response.type == 'braintree_customers' && response.data){

				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }

  create(customer: Braintree_customer): Promise<Braintree_customer> {
    let post_data = {
        data: {
          type: 'braintree_customer',
          attributes: { braintree_customer: customer }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'accounting/banking/braintree_create_customer',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='sms_braintree_customer') {
                         resolve(response.data);
                       }  else {
                         if(response.text){
                           reject(response.text);
                         } else {
                          reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : error);
                  }
             });
           });
  }

  hide(customer: Braintree_customer): Promise<boolean> {
  	let put_data = {
        data: {
          type: 'customer_hide_request',
          attributes: { system_customer_id: customer.system_customer_id }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'accounting/banking/braintree_customers',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='customer_hide_response') {
                       	resolve(response.data);
                       }  else {
                       	if(response.text){
                       		reject(response.text);
                       	} else {
                        	reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
  }

}
